<template>
  <div v-if="maintenance && maintenance.status === 'on' " style="white-space: pre-wrap; height: 100vh">
    {{ maintenance.body }}
  </div>
</template>

<script>
export default {
  name: 'Maintenance',
  data () {
    return {
      maintenance: this.$store.getters.maintenance || null
    }
  }
}
</script>
